import type { CameraPreviewPlugin } from "./definitions";
import { registerPlugin } from "@capacitor/core";

const CameraPreview = registerPlugin<CameraPreviewPlugin>(
    "CameraPreview",
    { "web": async () => import("./web").then((module) => new module.CameraPreviewWeb()) },
);

export * from "./definitions";

export { CameraPreview };
